import * as $ from 'jquery';
import 'bootstrap';
import 'MagnificPopup';
import * as Cookies from 'js-cookie';
import {headerContent} from './c002';
import {bookingFormCommon} from './c005-bookingform-common';

export class loginForm {

	$ibeNav: any = $('#bookingNav.cug');
	$mobIbeNav: any = $('#mab-header.mobile #slide-nav');
	$mobIbeNav_cug: any = $('#mab-bookingnav.mobile');
	$moblogin   : any      = this.$mobIbeNav_cug.find('#mob-login--container');
	$moblogin_cont: any      = this.$mobIbeNav_cug.find('#mob-logged-in-user-menu');

	nav(): void {
		let _self = this;
		let $loggedInMenu:any    = $('#logged-in-user-menu');
		let $mobLoggedInMenu:any = $('#mob-logged-in-user-menu');
		let loggedIn = _self.isUserLoggedIn();

		if (loggedIn) {
			_self.$ibeNav.find('.login-nav .login-success').addClass('logged-in');
			_self.$ibeNav.find('.login-nav .login').addClass('logged-in');
			$('.login ').hide();
			$('.login-success').show();
		} else {
			_self.$ibeNav.find('.login-nav .login-success').removeClass('logged-in');
            _self.$ibeNav.find('.login-nav .login').removeClass('logged-in');
		}

		// toggle desktop enrich login menu
		_self.$ibeNav.find('.login-nav .login-success').click(function() {
			_self.$ibeNav.find('li').removeClass('selected');
			_self.$ibeNav.find('.login-nav .login-success').parent().addClass('selected');
			$(this).addClass('active');
			$loggedInMenu.toggleClass('hidden');
        });
        let mobIsOpen:boolean = false;
		if (loggedIn) {

			_self.$moblogin.css({
				'display': 'block',
				'border': 'none',
				'padding': '0',
				'width': 'calc(100% + 30px)',
				'left': '-15px'
			});

			_self.$moblogin_cont.css({
				'top': '0',
				'width': '100%',
				'position': 'absolute',
				'z-index': '999'
            });
            
		}
		_self.$mobIbeNav.find('.enrich-login').click(function(e:any) {
			e.preventDefault();
			e.stopPropagation();

			if (!mobIsOpen) {               
				_self.$moblogin_cont.css('display', '');
                _self.$moblogin_cont.removeClass('hidden');
				mobIsOpen = true;
			} else {
				_self.$moblogin_cont.css('display', 'none');
                _self.$moblogin_cont.addClass('hidden');
				mobIsOpen = false;
			}
		});
	}

	isUserLoggedIn():boolean {
		let _self = this;
		let $paramCug     = $('#search-param-cug').val();
		let $isCuglogin    = $('#loggenInUser').val();
		if ($paramCug && $isCuglogin=='1' ) {
        if($('#cug-partner-name').val()!="" && $('#cug-user-name').val()!="")
        {
            return true;
		}
		else{
            return false;
		}		
	}
	else
	{
		return false;
	}
    }

	clearUserDataOnLogout():void {

            $('#bookingNav').find('.login-nav').on('click', function () {
                $('#logged-in-user-menu').toggleClass('hidden');
            });
                document.cookie = 'cug' + '=;Path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                var cugLoginPagePathCookieVal = document.cookie.match('(^|;)\\s*cug-login-page-path\\s*=\\s*([^;]+)');
                document.cookie = "cug-login-page-path=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                if (cugLoginPagePathCookieVal != null) {
                    var cugLoginPagePath = cugLoginPagePathCookieVal ? cugLoginPagePathCookieVal.pop() : '';
                    document.cookie = 'cug-login-page-path' + '=;Path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    window.location.replace(cugLoginPagePath);
                } else {
                    location.reload();
                }
								document.cookie = "profileSessionEnabled=true; expires=Thu, 01 Jan 1970 00:00:01 GMT";

	}

	logOutUser():void {
		let _self = this;
		let redirectTo:string = $("#cuglogoutLink").attr("data-redirectto");

		_self.clearUserDataOnLogout();

		if (redirectTo && redirectTo != "") {
			window.location.href = redirectTo;
		} else {
			location.reload();
		}
	}

	redirectUser(msg:string):void {
		if(msg.indexOf("timeout") > -1) {
			msg = msg.replace("timeout-","");
			window.location.href = msg;
		}
	}

	logoutHandler(): void {
		let _self = this;
    $("#cugLogoutLink").on("click",function() {
		document.cookie = 'cug' + '=;Path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		document.cookie = "cug-login-page-path=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	  	_self.logOutUser();
	});
    $("#cuglogoutLink").on("click",function() {
		document.cookie = 'cug' + '=;Path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		document.cookie = "cug-login-page-path=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	  	_self.logOutUser();
	});	
	}

}

let scope:Element = document.querySelector('.mhenterpse-login');
if (scope){
	try {
		let loginform = new loginForm();
		let $isCuglogin    = $('#loggenInUser').val();
		if ($isCuglogin=='1')
		{
			$("a.enrich-login").removeAttr("href");
		}
		$(document).ready(function(){
			loginform.nav();			
		});
		loginform.logoutHandler();
	} catch(e) {console.error(e);}
}
